import { type MetricField, type MyLensesOrganicStatsResponseEntry } from "../../gql-generated/types";
import { formatNumbers } from "../../lens-stats/formatters";
import { getKeys } from "../../shared/utils/object";
import { ejectTotalMetricValue } from "../filters";
import { type InsightsMetrics, type InsightsMetricsMap, type StatsItem } from "../models";

export const mapLifetimeTotalValues = (
    metrics: Partial<Record<MetricField, InsightsMetrics<StatsItem>>>,
    responseLifetimeValues: readonly MyLensesOrganicStatsResponseEntry[],
): InsightsMetricsMap<StatsItem> => {
    if (responseLifetimeValues.length > 0) {
        getKeys(metrics).forEach((item: MetricField) => {
            const totalValue = Number.parseInt(ejectTotalMetricValue(responseLifetimeValues, item));
            const metric = metrics[item];
            if (totalValue && metric) {
                metric.totalValueFormatted = formatNumbers(totalValue);
            }
        });
    }

    return metrics;
};
